import { render, staticRenderFns } from "./dialog_addCage.vue?vue&type=template&id=5b0e6d2a&scoped=true&"
import script from "./dialog_addCage.vue?vue&type=script&lang=js&"
export * from "./dialog_addCage.vue?vue&type=script&lang=js&"
import style0 from "./dialog_addCage.vue?vue&type=style&index=0&id=5b0e6d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e6d2a",
  null
  
)

export default component.exports